import { render, staticRenderFns } from "./Calculate.vue?vue&type=template&id=55a3b8f2&"
import script from "./Calculate.vue?vue&type=script&lang=js&"
export * from "./Calculate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports